import {
  API_KEY,
  API_ORDENES_URL,
  API_ESPECIALIDADES_URL,
  API_LOCALIDADES_URL,
  API_PRACTICAS_URL,
  API_PRESTADORES_URL,
  API_EFECTORES_URL,
  API_PROVINCIAS_URL,
  API_SYSTEM_URL,
  API_REVERSE_GEO,
  API_NOTIFICACIONES_URL,
  API_DOWNLOAD_ORDER
} from '../constants';

require('es6-promise').polyfill();
require('isomorphic-fetch');

export const api = {

  fetchSpecialties: ({ sessionId }) => {

      return dispatch({
        url: `${API_ESPECIALIDADES_URL}`,
        sessionId: window.sessionId || sessionId
      });
  },

  fetchLocations: ({ provinceId, sessionId }) => {

    return dispatch({
      url: `${API_LOCALIDADES_URL}/${provinceId}`,
      sessionId: window.sessionId || sessionId
    });
  },

  fetchLocation: ({ locationId, sessionId }) => {

    return dispatch({
      url: `${API_SYSTEM_URL}/localidad/${locationId}`,
      sessionId: window.sessionId || sessionId
    });
  },

  fetchProvinces: ({ sessionId }) => {

    return dispatch({
      url: `${API_PROVINCIAS_URL}`,
      sessionId: window.sessionId || sessionId
    });
  },

  fetchOrders( { date_start=null, date_end=null, stateId=null, sessionId } ) {

    return dispatch({
      url: `${API_ORDENES_URL}`,
      method: "post",
      sessionId: window.sessionId || sessionId,
      body: {
        fecha_desde : date_start,
        fecha_hasta : date_end,
        estado : stateId,
      }
    });
  },

  fetchOrder( { orderId, sessionId } ) {
      return dispatch({
        url: `${API_ORDENES_URL}/${ orderId }`,
        sessionId: window.sessionId || sessionId
      });
  },

  fetchPracticesByOrder( {orderId, date_start='', date_end='', search='', frequency='', sessionId } ) {

      let filters = `fecha_desde=${date_start}&fecha_hasta=${date_end}&frequency=${frequency}`

      return dispatch({
        query: `${filters}`,
        url: `${API_ORDENES_URL}/${orderId}/practicas`,
        sessionId: window.sessionId || sessionId
      });
  },

  fetchEfectoresByPractice( { practiceId, sessionId} ){
    return dispatch({
      url: `${API_PRACTICAS_URL}/${practiceId}/efectores`,
      sessionId: window.sessionId || sessionId
    });
  },

  fetchVisitsByPracticeEfector( { practiceId, efectorId, sessionId} ){

    return dispatch({
      url: `${API_PRACTICAS_URL}/${practiceId}/efector/${efectorId}/visitas`,
      sessionId: window.sessionId || sessionId
    });
  },

  fetchProvider(user) {

    return dispatch({
      method: 'POST',
      url: `${API_PRESTADORES_URL}/login`,
      body: {
        user
      }
    });
  },

  fetchEfectores( { sessionId, especialidadId=0, provinciaId=0, localidadId=0 } ) {

    return dispatch({
      method: 'POST',
      url: `${API_EFECTORES_URL}/list`,
      sessionId: window.sessionId || sessionId,
      body: {
        especialidadId
	       ,provinciaId
         ,localidadId
      }
    });
  },

  fetchEfectorByDNI( { dni, sessionId } ) {

    return dispatch({
      url: `${API_EFECTORES_URL}/dni/${dni}`,
      sessionId: window.sessionId || sessionId
    });
  },

  fetchEfector( efectorId ) {

    return dispatch({
      url: `${API_EFECTORES_URL}/${efectorId}`,
      sessionId: window.sessionId
    });
  },

  updateEfector( { id, apellido, cuit, dni, email, especialidadId, localidadId, nombre, provinciaId, telefono1, telefono2 } ) {

    return dispatch({
      url: `${API_EFECTORES_URL}/${id}`,
      sessionId: window.sessionId,
      method: 'put',
      body: {
        id,
        apellido,
        cuit,
        dni,
        email,
        especialidadId,
        localidadId,
        nombre,
        provinciaId,
        telefono1,
        telefono2,
      }
    });
  },

  createEfector( { apellido, cuit, dni, email, especialidadId, localidadId, nombre, provinciaId, telefono1, telefono2} ) {
    return dispatch({
      url: `${API_EFECTORES_URL}/`,
      sessionId: window.sessionId,
      method: 'post',
      body: {
        apellido,
        cuit,
        dni,
        email,
        especialidadId,
        localidadId,
        nombre,
        provinciaId,
        telefono1,
        telefono2,
      }
    });
  },

  deleteEfector( efectorId ) {
    return dispatch({
      url: `${API_EFECTORES_URL}/${efectorId}`,
      sessionId: window.sessionId,
      method: 'DELETE'
    });
  },

  addPracticeEfector( { practiceId, efector, sessionId } ) {
    return dispatch({
      url: `${API_PRACTICAS_URL}/${practiceId}/efectores`,
      sessionId: window.sessionId || sessionId,
      method: 'POST',
      body: {
        id: efector.id
      }
    });
  },

  deletePracticeEfector( { practicaId, efectorId, fechaInicio, fechaFin, sessionId  } ) {
    return dispatch({
      url: `${API_PRACTICAS_URL}/efector`,
      sessionId: window.sessionId || sessionId,
      method: 'DELETE',
      body: {
        practicaId,
        efectorId,
        fechaInicio,
        fechaFin,
      }
    });
  },

  updatePracticeEfector( { id, comentarios,  efectorApellido,   efectorId,  efectorNombre,   fechaFin,  fechaInicio,  practicaId, sessionId } ) {
    return dispatch({
      url: `${API_PRACTICAS_URL}/efector`,
      sessionId: window.sessionId || sessionId,
      method: 'POST',
      body: {
        comentarios,
        efectorApellido,
        efectorId,
        efectorNombre,
        fechaFin,
        fechaInicio,
        practicaId,
        id
      }
    });
  },

  fetchNotifications( { notificationId, sessionId } ){
    return dispatch({
      url: `${API_NOTIFICACIONES_URL}/${notificationId}`,
      sessionId: window.sessionId || sessionId,
    });
  },

  updateStatusNotification(notificationId){
    return dispatch({
      url: `${API_NOTIFICACIONES_URL}/${notificationId}`,
      sessionId: window.sessionId,
      method: 'POST',
    });
  },

        /*
         * POST /api/practicas/efector
            -	Request: PracticaEfectorModel
            -	Response: HTTP-OK
            -	Funcionalidad: Actualiza la asignación de un Efector a una Práctica. Principalmente para actualizar el dato COMENTARIOS, pero podría utilizarse para cambiar fechas se fuese necesario.
            -	Fuente: DB/cdom_practicas_efectores
         */

  fetchAddres( { lat, lng } ){
    let filters = `format=json&lat=${lat}&lon=${lng}`

    return dispatch({
      query: `${filters}`,
      url: `${API_REVERSE_GEO}`,
    });
  },

  rejectPractice( {id, motive} ) {
      return dispatch({
        method: 'POST',
        url: `${API_PRACTICAS_URL}/${id}/rechazo`,
        sessionId: window.sessionId,
        body: {
            motivo: motive
        }
      })
  },

  async importEfectores( file ) {
    const formData = new FormData(); 
    formData.append('file',file)
    new Response(formData).text().then(console.log)
    console.log([...formData])

      return {data: await dispatch({
          method: 'post',
          url: `${API_EFECTORES_URL}/upload`,
          sessionId: window.sessionId,
          formData: formData,
          withoutContentType: true
      })
    }
  },

  resendLoginMailEfector( efectorId ) {
    return dispatch({
        url: `${API_EFECTORES_URL}/resend-login-mail/${efectorId}`,
        sessionId: window.sessionId,
    })
  },

  getOrderLinkPdf( orderNro, prestadorId, practicasIds = null ) {
    return dispatch({
        url: `${API_DOWNLOAD_ORDER}/pdf-link/${orderNro}/${prestadorId}/${practicasIds ? practicasIds : ''}`,
        sessionId: window.sessionId,
    })
  }

}

export function requestUrl({query, url}) {

  let params = []

  if (query) params.push(query);

  if ( params.length ) {
    url += url.indexOf('?') === -1 ? '?' : '&';
    url += params.join('&');
  }

  return url;
}

export function dispatch(options) {
   let headers = {
    'Authorization': API_KEY
  }

  if(!options.withoutContentType || options.ContentType) {
    headers['Content-Type'] = options.ContentTyp ? options.ContentType : 'application/json'
  }

  if ( options.sessionId ){
    headers['SessionId'] = options.sessionId;
  }

  let data = {
    'mode': 'cors',
    'credentials': 'same-origin',
    'method': options.method || 'get',
    'headers': headers,
  }

  if ( options.body ){
    data['body'] = JSON.stringify(options.body);
  }

  if( options.formData ){
    data['body'] = options.formData
  }

  return fetch(requestUrl(options), data ).then((response) => {
      if (response.status === 404)
        return {errors: 404}

      if (response.status === 401)
          return {errors: 401}

      return response.json()


  })
}
